function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};


class HeaderWrapper extends HTMLElement{
  constructor(){
    super()

    this.type = this.dataset.type
    this.scrollPosition = window.scrollY
    this.isTransparent = this.querySelector('.header--transparent')
    this.spacing = this.dataset.spacing == "true"
    if(this.type == "scroll_up"){
      window.addEventListener("scroll", ()=>{
        this.handleHeaderScrolling()
      })
    }
    
    window.addEventListener("scroll", ()=>{
      if(window.scrollY > 10){
        this.classList.add("scrolled")
      }else{
        this.classList.remove("scrolled")
      }
    })


    if(this.isTransparent){
      //Handle scrolling
      window.addEventListener("scroll", ()=>{
        this.handleTransparentHeader()
      })

      this.addEventListener("mouseenter", ()=>{this.querySelector("header").classList.remove("header--transparent")})
      this.addEventListener("mouseleave", ()=>{this.handleTransparentHeader()})
    }

    document.documentElement.style.setProperty("--total-header-height", this.offsetHeight+"px")
    document.querySelectorAll('.custom-mega-menu__inner').forEach(item=>{
      //item.style.paddingLeft = document.querySelector('.header .list-menu--inline').getBoundingClientRect().left + "px"
    })

    //Adapt total header height to the height of the header
    window.addEventListener("scroll", ()=>{
      document.documentElement.style.setProperty("--total-header-height", this.offsetHeight+"px")
    })

    if(this.spacing){
      document.documentElement.style.setProperty("--header-spacing", this.offsetHeight+"px")
      console.log(this.offsetHeight)
      window.addEventListener("resize", ()=>{
        document.documentElement.style.setProperty("--header-spacing", this.offsetHeight+"px")
      })
    }else{
        document.documentElement.style.setProperty("--header-spacing", 0)
    }
  }

  handleTransparentHeader(){
    if(window.scrollY > 0){
      this.querySelector("header").classList.remove("header--transparent")
    }else{
      this.querySelector("header").classList.add("header--transparent")
    }
  }

  handleHeaderScrolling(){
    var currentScrollPos = window.scrollY;

    if (this.scrollPosition > currentScrollPos){
      this.classList.remove("header__outer--scrolled");
    }
    else if(window.scrollY > 200){  
      this.classList.add("header__outer--scrolled");
    }
    this.scrollPosition = currentScrollPos;
  }
}

customElements.define("header-wrapper", HeaderWrapper)


customElements.define("chat-toggler", class ChatToggler extends HTMLElement{
  constructor(){
    super()

    
    
    this.addEventListener("click", ()=>{
      console.log(document.querySelector('#ShopifyChat').contentDocument)
      const btn = document.querySelector('#dummy-chat-button-iframe').contentDocument.querySelector('.chat-toggle')
      btn.click()
    })
  }
})


class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);


class HeaderDrawer extends HTMLElement {
  constructor() {
    super();

    this.toggleMenuBtn = this.querySelector('.js-open-menu')
    this.menu = document.querySelector(".mobile-menu")

    this.toggleMenuBtn.addEventListener("click", this.toggleMenuDrawer.bind(this))
  }

  toggleMenuDrawer(){
    if(this.menu.classList.contains("hide")){
      this.openMenuDrawer()
    }else{
      this.closeMenuDrawer()
    }
  }

  openMenuDrawer() {
    this.header = this.header || document.querySelector('.section-header');
    this.header.classList.add('menu-open');
    document.body.classList.add("overflow-hidden")
    
    // setTimeout(() => {
      //   this.mainDetailsToggle.classList.add('menu-opening');
      // });
      //window.location.pathname == "/" ? this.header.querySelector('.header').classList.remove("header--transparent") : null
      this.menu.classList.remove("hide")
      setTimeout(()=>{
        this.menu.querySelector('.mobile-menu__inner').classList.remove('hide')
        this.menu.querySelector('.mobile-menu__menu-sublinks').classList.remove('hide')
        this.menu.querySelector('.mobile-menu__footer').classList.remove('hide')
      }, 300)

    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
  
  closeMenuDrawer() {
    this.header.classList.remove('menu-open');
    document.body.classList.remove("overflow-hidden")
    this.menu.querySelector('.mobile-menu__inner').classList.add('hide')
    this.menu.querySelector('.mobile-menu__menu-sublinks').classList.add('hide')
    this.menu.querySelector('.mobile-menu__footer').classList.add('hide')
    setTimeout(()=>{
      this.menu.classList.add("hide")
    }, 300)
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button') || this;

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) {
        modal.show(button);
        //Scroll to current image position
        console.log(modal)
        const currentImage = modal
      }
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    try{
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }       
  }catch(e){}
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);

    this.setDisabledLabels()
  }

  setDisabledLabels(){
    const isSingleOption = !this.getVariantData()[0].option2
    console.log(this.getVariantData(), isSingleOption)
    if(isSingleOption){
      const disabledOptions = this.getVariantData().filter(variant => {return !variant.available})
      disabledOptions.forEach(option=>{
        const optionInput = this.querySelector(`.product-form__input input[value="${option.option1}"]`)
        const optionLabel = this.querySelector(`.product-form__input label[for="${optionInput.id}"]`)
        optionLabel.classList.add("disabled")
      })
    }
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      const bisBtn = document.getElementById('BIS_trigger')
      bisBtn.style.display = "none"
      this.updateMedia();
      !this.closest('featured-product') && this.updateURL()
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
    console.log(this.currentVariant)
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    //mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #${this.dataset.section}`) ;
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      console.log(this.currentVariant.id)
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        console.log(this.currentVariant.available)
        const bisBtn = document.getElementById('BIS_trigger')


        if(this.currentVariant.available){
          bisBtn.style.display = "none"
        }else{
          bisBtn.removeAttribute("style")
        }

        //Toggle variant low stock message
        document.querySelector('.product-form__last-units').outerHTML = html.querySelector('.product-form__last-units').outerHTML
        if(parseInt(document.querySelector('.product-form__last-units').dataset.quantity) <= 10 && parseInt(document.querySelector('.product-form__last-units').dataset.quantity) > 0){
          document.querySelector('.product-form__last-units').classList.remove("hidden")
        }

        //Toggle presale
        document.querySelector('.product-form__presale').outerHTML = html.querySelector('.product-form__presale').outerHTML

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    console.log(`product-form-${this.dataset.section}`)
    const productForm = document.getElementById(`product-form-${this.dataset.section}`) || document.getElementById(`${this.dataset.section}`);
    productForm.querySelector('.js-select-size')?.classList.add("hidden")
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      !this.closest('.ugc-product-form') && (addButtonText.textContent = window.variantStrings.addToCart);
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);



if(!customElements.get("product-image-slider")){
  customElements.define("product-image-slider", class ProductImageSlider extends HTMLElement{
      constructor(){
          super()

          this.arrowPrev = this.querySelector('.js-prev-slide')
          this.arrowNext = this.querySelector('.js-next-slide')
          this.slides = this.querySelectorAll(".ProductItem__Image")
          this.currentSlide = 0
          this.maxSlides = this.slides.length - 1

          this.arrowPrev.addEventListener("click", this.prevSlide.bind(this))
          this.arrowNext.addEventListener("click", this.nextSlide.bind(this))
      }

      prevSlide(e){
          e.preventDefault()
          this.currentSlide = this.currentSlide == 0 ? this.maxSlides : this.currentSlide-1
          this.slides.forEach(slide=>slide.classList.remove("ProductItem__Image--shown"))
          this.slides[this.currentSlide].classList.add("ProductItem__Image--shown")
      }
      
      nextSlide(e){
          e.preventDefault()
          this.currentSlide = this.currentSlide == this.maxSlides ? 0 : this.currentSlide+1
          console.log(this.currentSlide)
          this.slides.forEach(slide=>slide.classList.remove("ProductItem__Image--shown"))
          this.slides[this.currentSlide].classList.add("ProductItem__Image--shown")
      }
  })
}

document.addEventListener("DOMContentLoaded", ()=>{
  const localizationTogglers = document.querySelectorAll('.js-toggle-localization')
  localizationTogglers.forEach(btn=>{
    btn.addEventListener("click", ()=>{
      document.querySelector('geolocation-modal').classList.remove("hidden")
    })
  })
})


customElements.define("multi-collection-slider", class MultCollectionSlider extends HTMLElement{
  constructor(){
    super()

    this.togglers = this.querySelectorAll('.js-toggle-collection')
    this.sliders = this.querySelectorAll('.swiper')

    this.init()

    this.togglers.forEach((toggler, index)=>{
      toggler.addEventListener("click", ()=>this.toggleSlider(index+1))
    })
  }

  toggleSlider(slideIndex){
    //Change sliders
    this.sliders.forEach(slider=>slider.classList.add("hidden"))
    this.querySelector(`.multi-collection-slider__wrapper--${slideIndex}`).classList.remove("hidden")
    
    //Change btns
    this.togglers.forEach((toggler, index)=>{
      if(index+1 == slideIndex){
        toggler.classList.remove('btn--tertiary')
        toggler.classList.add('btn--secondary')
      }else{
        toggler.classList.add('btn--tertiary') 
        toggler.classList.remove('btn--secondary')
      }
    })
  }

  init(){
    this.sliders.forEach(slider=>{
      new Swiper(slider, {
        slidesPerView: 1.5,
        centeredSlides: true,
        loop: true,
        initialSlide: 1,
        navigation:{
          prevEl: '.slider-prev',
          nextEl: '.slider-next'
        },
        breakpoints: {
          600:{
            slidesPerView: 3,
            centeredSlides: false,
            loop: false,
            initialSlide: 0
          },
          989:{
            slidesPerView: 5,
            centeredSlides: false,
          }
        }
      })
    })
  }
})


customElements.define("multi-featured-collection", class MultiFeaturedCollection extends HTMLElement{
  constructor(){
    super()

    this.togglers = this.querySelectorAll('.js-toggle-collection')
    this.sliders = this.querySelectorAll('.swiper')

    this.init()

    this.togglers.forEach((toggler, index)=>{
      toggler.addEventListener("click", ()=>this.toggleSlider(index+1))
    })
  }

  toggleSlider(slideIndex){
    //Change sliders
    this.sliders.forEach(slider=>slider.classList.add("hidden"))
    this.querySelector(`.multi-featured-collection__wrapper--${slideIndex}`).classList.remove("hidden")
    
    //Change btns
    this.togglers.forEach((toggler, index)=>{
      if(index+1 == slideIndex){
        toggler.classList.remove('btn--tertiary')
        toggler.classList.add('btn--secondary')
      }else{
        toggler.classList.add('btn--tertiary') 
        toggler.classList.remove('btn--secondary')
      }
    })
  }

  init(){
    this.sliders.forEach(slider=>{
      new Swiper(slider, {
        slidesPerView: 1.5,
        centeredSlides: true,
        initialSlide: 1,
        loop: true,
        navigation:{
          prevEl: '.slider-prev',
          nextEl: '.slider-next'
        },
        breakpoints: {
          600:{
            slidesPerView: 3.2,
            initialSlide: 0,
            loop: false,
            centeredSlides: false
          },
          989:{
            slidesPerView: 5.2,
            initialSlide: 0,
            loop: false,
            centeredSlides: false
          }
        }
      })
    })
  }
})

customElements.define("mega-menu-toggler", class MegaMenuToggler extends HTMLElement{
  constructor(){
    super()

    this.itemId = this.dataset.menuId
    this.relatedMegaMenu = document.getElementById(this.itemId)

    console.log(this.itemId)
    console.log(this.relatedMegaMenu)

    this.addEventListener("mouseenter", ()=>{
      document.getElementById(this.itemId).classList.add('hovered')
    })
    this.addEventListener("mouseleave", ()=>document.getElementById(this.itemId).classList.remove('hovered'))
  }
})


//Infinite scroll functionality
class InfiniteScroll extends HTMLElement{
  constructor(){
    super()

    this.productGrid = this.closest('.collection').querySelector('#product-grid')
    this.loadedNext = false
    this.currentQuery = window.location.href.split("?")[1]

    this.checkPagination()
  }

  checkPagination(){
    const intersectionObserver = new IntersectionObserver((entries)=>{
      if(entries[0].intersectionRatio > 0){
        var baseUrl = this.dataset.baseUrl + "?view=ajax"
        if(this.currentQuery){
          baseUrl = baseUrl + this.currentQuery
        }
        if(parseInt(this.dataset.currentPage) < parseInt(this.dataset.totalPages)){
          fetch(`${baseUrl}&page=${parseInt(this.dataset.currentPage)+1}`)
          .then(res=>res.text())
          .then(res=>{
            this.loadedNext = true
            const html = document.createElement("div")
            html.innerHTML = res
            const gridItems = html.querySelector('#product-grid').innerHTML
            this.productGrid.innerHTML += gridItems
            this.setAttribute("data-current-page", parseInt(this.dataset.currentPage) + 1)
            this.loadedNext = false

            document.querySelectorAll('.ProductItem__Image-Outer').forEach(item=>{
              new Swiper(item,{
                slidesPerView: 1,
                loop: true,
                pagination: {
                    el: '.product-image-slider__pagination',
                    type: 'bullets'
                },
                navigation: {
                    prevEl: ".js-prev-slide",
                    nextEl: ".js-next-slide"
                }
              })
            })
          })
        }else{
          this.classList.add("hidden")
          intersectionObserver.disconnect()
        }
      }
    })

    intersectionObserver.observe(this)
  }
}


customElements.define("infinite-scroll", InfiniteScroll)

document.addEventListener("DOMContentLoaded", ()=>{
    const lookTogglers = document.querySelectorAll('.js-toggle-look')
    lookTogglers.forEach(toggler=>{
        toggler.addEventListener("click", ()=>{
            toggler.closest('.shop-the-look__block').classList.toggle('opened')
        })
    })
})


document.addEventListener("DOMContentLoaded", ()=>{
    //Hide items in mobile and desktop
    const hideDesktop = document.querySelectorAll(".desktop-remove")
    const hideMobile = document.querySelectorAll(".mobile-remove")

    if(window.innerWidth > 990){
      hideDesktop.forEach(item=>item.outerHTML = "")
    }else{  
      hideMobile.forEach(item=>item.outerHTML = "")
      //document.querySelector('.product__info-container .breadcrumb').outerHTML = ""
    }
})



class AccountContent extends HTMLElement{
  constructor(){
    super()

    this.toggleItems = this.querySelectorAll(".account__tools-wrapper__tool-link:not(.account__tools-wrapper__tool-link--logout)")
    this.contentItems = this.querySelectorAll(".account__blocks-wrapper__block")
    this.currentBlock = window.location.hash || "#details"
    this.closeBtns = this.querySelectorAll('.js-close-account-block')

    window.innerWidth > 990 && this.init()

    this.closeBtns.forEach(item=>{
      item.addEventListener("click", ()=>{
        this.contentItems.forEach(item=>item.classList.add("hidden"))
        this.toggleItems.forEach(item=>item.classList.remove("active"))
        document.body.classList.remove("overflow-hidden-mobile")
      })
    })

    this.toggleItems.forEach(item=>{
      item.addEventListener("click", (e)=>{
        e.preventDefault()
        this.currentBlock = item.getAttribute("href")
        this.init()
        window.innerWidth < 990 && document.body.classList.add("overflow-hidden-mobile")
        history.pushState(null,null,this.currentBlock);
      })
    })
  }

  init(){
    this.contentItems.forEach(item=>item.classList.add("hidden"))
    this.querySelector(`${this.currentBlock}`).classList.remove("hidden")

    this.toggleItems.forEach(item=>item.classList.remove("active"))
    this.toggleItems.forEach(item=>{
      console.log(item.getAttribute("href"))
      if(item.getAttribute("href") == this.currentBlock){
        item.classList.add("active")
      }
    })
  }
}

customElements.define("account-content", AccountContent)


customElements.define("wishlist-button", class WishlistButton extends HTMLElement{
  constructor(){
    super()
  }
})


customElements.define('featured-product', class FeaturedProduct extends HTMLElement{
  constructor(){
    super()

    this.colorSwatches = Array.from(this.querySelectorAll(".product-swatches__swatch-link"))

    this.colorSwatches.forEach(swatch=>{
      swatch.addEventListener("click", (e)=>{
        e.preventDefault()
        fetch(`${e.target.closest('a').href}?section_id=featured-product`)
        .then(res=>res.text())
        .then(text=>{
          
          const newProduct = new DOMParser().parseFromString(text, 'text/html')
          console.log(newProduct)
          this.closest("[data-section='featured-product']").innerHTML = newProduct.querySelector("[data-section='featured-product']").innerHTML
        })
      })
    })  
  }
})


customElements.define("ugc-videos", class UgcVideos extends HTMLElement{
  constructor(){
    super()

    this.nextVideoBtn = this.querySelector(".ugc-videos__videos-controls__next")
    this.prevVideoBtn = this.querySelector(".ugc-videos__videos-controls__prev")
    this.muteBtn = this.querySelector(".ugc-videos__videos-controls__mute")
    this.closeBtn = this.querySelector(".ugc-videos__videos-controls__close")
    this.videosWrapper = this.querySelector(".ugc-videos__videos-inner")
    this.videos = Array.from(this.querySelectorAll(".ugc-videos__item-video"))
    this.modalContainer = this.querySelector('.ugc-videos__videos')
    this.currentIndex = 0
    this.isAnimating = false
    this.lastScrollTime = 0
    this.scrollThreshold = 1000
    this.scrollAccumulator = 0
    this.scrollThresholdPixels = 100
    
    this.setupEventListeners()
    this.setupVideoControls()
  }

  setupEventListeners() {
    // Toggle video modal on thumbnail click
    this.querySelectorAll('.js-toggle-video').forEach(toggle => {
      toggle.addEventListener('click', () => {
        const videoId = toggle.dataset.video
        this.openVideoModal(videoId)
      })
    })

    // Next/Previous video controls
    this.nextVideoBtn?.addEventListener('click', (e) => {
      e.stopPropagation() // Prevent click from reaching modal
      this.showNextVideo('next')
    })
    this.prevVideoBtn?.addEventListener('click', (e) => {
      e.stopPropagation() // Prevent click from reaching modal
      this.showNextVideo('prev')
    })
    
    // Mute toggle
    this.muteBtn?.addEventListener('click', (e) => {
      e.stopPropagation() // Prevent click from reaching modal
      this.toggleMute()
    })

    // Scroll-based navigation
    this.videosWrapper.addEventListener('wheel', (e) => this.handleScroll(e), { passive: false })
    this.videosWrapper.addEventListener('touchstart', (e) => this.handleTouchStart(e))
    this.videosWrapper.addEventListener('touchend', (e) => this.handleTouchEnd(e))

    // Play/Pause on video click
    this.videos.forEach(video => {
      video.addEventListener('click', (e) => {
        e.stopPropagation() // Prevent click from reaching modal
        if(!e.target.closest('.ugc-product-form')){
          this.togglePlayPause()
        }
      })
    })

    // Close modal when clicking outside
    this.modalContainer.addEventListener('click', (e) => {
      if (e.target === this.modalContainer) {
        this.closeModal()
      }
    })

    // Add escape key listener
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.modalContainer.classList.contains('active')) {
        this.closeModal()
      }
    })

    // Close button
    this.closeBtn?.addEventListener('click', (e) => {
      e.stopPropagation()
      this.closeModal()
    })
  }

  handleScroll(e) {
    e.preventDefault()
    
    if (this.isAnimating) return
    
    const currentTime = Date.now()
    if (currentTime - this.lastScrollTime < this.scrollThreshold) {
      return
    }

    this.scrollAccumulator += e.deltaY

    if (Math.abs(this.scrollAccumulator) >= this.scrollThresholdPixels) {
      const direction = this.scrollAccumulator > 0 ? 'next' : 'prev'
      this.showNextVideo(direction)
      this.lastScrollTime = currentTime
      this.scrollAccumulator = 0 // Reset accumulator after triggering
    }
  }

  handleTouchStart(e) {
    this.touchStartY = e.touches[0].clientY
  }

  handleTouchEnd(e) {
    if (this.isAnimating) return
    
    const touchEndY = e.changedTouches[0].clientY
    const deltaY = this.touchStartY - touchEndY
    
    if (Math.abs(deltaY) > 50) { // minimum swipe distance
      if (deltaY > 0) {
        this.showNextVideo('next')
      } else {
        this.showNextVideo('prev')
      }
    }
  }

  setupVideoControls() {
    // Pause all videos except the current one
    this.videos.forEach((video, index) => {
      if (index !== this.currentIndex) {
        const videoEl = video.querySelector('video')
        videoEl.pause()
        videoEl.currentTime = 0
      }
    })
  }

  togglePlayPause() {
    const currentVideo = this.videos[this.currentIndex].querySelector('video')
    if (currentVideo.paused) {
      currentVideo.play()
    } else {
      currentVideo.pause()
    }
  }

  closeModal() {
    this.modalContainer.classList.remove('active')
    const currentVideo = this.videos[this.currentIndex].querySelector('video')
    currentVideo.pause()
    currentVideo.currentTime = 0
    document.body.classList.remove('overflow-hidden')
  }

  openVideoModal(videoId) {
    const video = this.querySelector(`.ugc-videos__item-video[data-video="${videoId}"]`)
    const index = this.videos.indexOf(video)
    if (index !== -1) {
      this.currentIndex = index
      this.videos.forEach(v => v.classList.remove('active'))
      video.classList.add('active')
      const videoEl = video.querySelector('video')
      videoEl.currentTime = 0
      videoEl.play()
      this.modalContainer.classList.add('active')
      document.body.classList.add('overflow-hidden')
    }
  }

  showNextVideo(direction) {
    if (this.isAnimating) return
    this.isAnimating = true

    const currentVideo = this.videos[this.currentIndex]
    const currentVideoEl = currentVideo.querySelector('video')
    currentVideoEl.pause()
    
    // Calculate next index with loop
    this.currentIndex = direction === 'next' 
      ? (this.currentIndex + 1) % this.videos.length
      : (this.currentIndex - 1 + this.videos.length) % this.videos.length

    const nextVideo = this.videos[this.currentIndex]
    const nextVideoEl = nextVideo.querySelector('video')
    
    // Reset video to beginning
    nextVideoEl.currentTime = 0

    // Add animation classes
    currentVideo.classList.add(direction === 'next' ? 'slide-up' : 'slide-down')
    nextVideo.classList.add(direction === 'next' ? 'slide-up-new' : 'slide-down-new')
    
    // After animation completes
    setTimeout(() => {
      currentVideo.classList.remove('active', 'slide-up', 'slide-down')
      nextVideo.classList.remove('slide-up-new', 'slide-down-new')
      nextVideo.classList.add('active')
      nextVideoEl.play()
      this.isAnimating = false
    }, 300)
  }

  toggleMute() {
    const currentVideo = this.videos[this.currentIndex].querySelector('video')
    currentVideo.muted = !currentVideo.muted
    this.muteBtn.classList.toggle('muted')
  }
})

customElements.define("card-product", class CardProduct extends HTMLElement{
  constructor(){
    super()
    this.controller = null
    this.attachSwatchListeners()
  }

  attachSwatchListeners() {
    this.swatches = Array.from(this.querySelectorAll(".product-swatches__swatch-link"))
    this.swatches.forEach(swatch => {
      swatch.addEventListener("mouseenter", this.debounce(this.handleSwatchHover.bind(this), 150))
    })
  }

  debounce(fn, delay) {
    let timeoutId
    return function (...args) {
      if (timeoutId) {
        clearTimeout(timeoutId)
      }
      timeoutId = setTimeout(() => {
        fn.apply(this, args)
        timeoutId = null
      }, delay)
    }
  }

  async handleSwatchHover(e) {
    e.preventDefault()
    
    // Cancel previous request if it exists
    if (this.controller) {
      this.controller.abort("Existing request")
    }

    // Create new controller for this request
    this.controller = new AbortController()

    try {
      const response = await fetch(`${e.target.href}?view=card-collection`, {
        signal: this.controller.signal
      })
      const text = await response.text()
      const newProduct = new DOMParser().parseFromString(text, 'text/html')
      this.innerHTML = newProduct.querySelector(".card-wrapper").outerHTML
      this.attachSwatchListeners()
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error('Error updating product card:', error)
      }
    } finally {
      this.controller = null
    }
  }
})